const { sites } = require("../config/sites")

const site = process.env.SITE
if (!site) {
  throw new Error("La variable d'env. 'SITE' n'est pas définie.")
}

if (!Object.keys(sites).find((s) => s === site)) {
  throw new Error(
    `le site '${site}' n'est pas configuré dans src/config/sites.js`
  )
}

const siteProps = sites[site]

module.exports = {
  site,
  siteProps,
  sites,
}
